<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @opened="onOpened" @close="onClose" width="80%" title="添加订单合同归档记录"
               :modal-append-to-body="true" :append-to-body="true">
      <el-row :gutter="15">
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: 600">添加合同归档信息</span>
            </div>
            <div style="height: 400px;">
              <el-form :inline="false" size="mini" :model="formContract" :rules="formContractRules" ref="formContract"
                       label-width="88px">
                <el-form-item label="合同编号" prop="contract_no">
                  <el-input v-model="formContract.contract_no" placeholder="合同编号"></el-input>
                </el-form-item>
                <el-form-item label="合同金额" prop="contract_amount">
                  <el-input v-model="formContract.contract_amount" oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                            placeholder="合同金额"></el-input>
                </el-form-item>
                <el-form-item label="收款形式" prop="payment_method">
                  <el-select v-model="formContract.payment_method" placeholder="请选择收款形式" style="width: 100%" clearable>
                    <el-option :value="1" label="先票后款"></el-option>
                    <el-option :value="2" label="先款后票"></el-option>
                    <el-option :value="3" label="预付款后开票"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否保量" prop="is_quantity">
<!--                  <el-input v-model="formContract.is_quantity" placeholder="是否保量"></el-input>-->
                  <el-select v-model="formContract.is_quantity" placeholder="请选择是否保量" style="width: 100%" clearable>
                    <el-option :value="`Y`" label="是"></el-option>
                    <el-option :value="`N`" label="否"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="佣金比例">
                  <el-input v-model="formContract.commission_rate" oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                            placeholder="佣金比例(保量2位小数)"></el-input>
                </el-form-item>
                <el-form-item label="财务备注">
                  <el-input v-model="formContract.f_remark" placeholder="财务备注"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveContract('formContract')" class="el-button--operation">保存
                  </el-button>
                  <el-button @click="resetForm('formContract')">重置</el-button>
                </el-form-item>
              </el-form>
              <p style="color: #E6A23C;font-size: 0.9rem;font-style: italic;font-weight: 600;text-align: left;margin-top: 50px">
                PS:若录入合同编号，则标记该订单合同归档状态为已归档</p>
            </div>
          </el-card>
        </el-col>
        <el-col :span="18">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: 600">关联订单</span>
            </div>
            <div class="default-table"
                 v-loading="contractLoading"
                 element-loading-text="玩命加载中……"
                 element-loading-spinner="el-icon-loading">

              <el-table :max-height="400"
                        :data="tableData"
                        :summary-method="getSummaries"
                        show-summary
                        border>
                <el-table-column
                    width="60"
                    label="序号" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <!--                <el-table-column key="id" label="订单ID" prop="id" align="left" :min-width="80"></el-table-column>-->
                <el-table-column key="order_no" label="订单编号" prop="order_no" header-align="center" align="left"
                                 :min-width="140"></el-table-column>
                <el-table-column key="company_name" label="乙方名称" prop="company_name" header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :min-width="100"></el-table-column>
                <el-table-column key="customer_name" label="客户名称" prop="customer_name" header-align="center"
                                 align="left"
                                 show-overflow-tooltip
                                 :min-width="160"></el-table-column>
                <el-table-column key="payment_account" label="订单总额" prop="payment_account" header-align="center"
                                 align="right"
                                 :min-width="110">
                  <template slot-scope="scope">
                    <span>{{ gFunc.numberFormat(scope.row.payment_account, 2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column key="contract_no" label="合同编号" prop="contract_no" header-align="center" align="center"
                                 :min-width="120"></el-table-column>
                <el-table-column key="payment_method" label="收款形式" prop="payment_method" header-align="center"
                                 align="center"
                                 :min-width="120"></el-table-column>
                <el-table-column key="is_quantity" label="是否保量" prop="is_quantity" header-align="center"
                                 align="center"
                                 :min-width="100">
                  <template slot-scope="{row}">{{ quantityMap[row.is_quantity] || '-' }}</template>
                </el-table-column>
                <el-table-column key="commission_rate" label="佣金比例" prop="commission_rate" header-align="center"
                                 align="center"
                                 :min-width="100">
                  <template slot-scope="{row}"><span class="rate">{{row.commission_rate||'-'}}</span></template>
                </el-table-column>
                <el-table-column key="f_remark" label="财务备注" prop="f_remark" header-align="center"
                                 align="left"></el-table-column>
                <!--          <el-table-column key="contract_no" label="合同编号" prop="contract_no" align="left" header-align="center"-->
                <!--                           :min-width="144">-->
                <!--            <editable-cell :show-input="false" slot-scope="{row}" v-model="row.contract_no"-->
                <!--                           @change="saveCell(row,'contract_no')">-->
                <!--                          <span slot="content">-->
                <!--                            <span>{{ row.contract_no || '&#45;&#45;' }}</span>-->
                <!--                            <i class="el-icon-edit float-right"></i>-->
                <!--                          </span>-->
                <!--            </editable-cell>-->
                <!--          </el-table-column>-->
                <!--          <el-table-column key="f_remark" label="财务备注" prop="f_remark" header-align="center" align="left"-->
                <!--                           :min-width="144">-->
                <!--            <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.f_remark"-->
                <!--                           @change="saveCell(row,'f_remark')">-->
                <!--                          <span slot="content">-->
                <!--                            <span>{{ row.f_remark || '&#45;&#45;' }}</span>-->
                <!--                            <i class="el-icon-edit float-right"></i>-->
                <!--                          </span>-->
                <!--            </editable-cell>-->
                <!--          </el-table-column>-->
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {saveOrder} from "@/api/order";
import {gFunc} from "@/globalFunc";

export default {
  name: "AdContractEnter",
  props: {
    orderContractList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      formContract: {
        ids: [],
        contract_no: null,
        contract_amount: null,
        payment_method: null,
        is_quantity: null,
        commission_rate: null,
        f_remark: null
      },
      formContractRules: {
        contract_no: [
          {required: true, message: '请输入合同编号', trigger: 'blur'},
        ],
        contract_amount: [
          {required: true, message: '请输入合同金额', trigger: 'blur'},
        ],
        payment_method: [
          {required: true, message: '请选择收款形式', trigger: 'blur'},
        ]
      },
      tableData: [],
      contractLoading: false,
      quantityMap: {'Y': '是', 'N': '否'}
    }
  },
  watch: {
    orderContractList: {
      handler: function (newVal) {
        if (newVal && newVal.length) {
          this.tableData = [...this.orderContractList];
        }
      },
      immediate: true
    }
  },
  methods: {
    onOpened() {
      // this.$notify.info('合同归档窗口打开')
    },
    onClose() {
      this.$refs['formContract'].resetFields()
    },
    close() {
      this.$emit('update:visible', false)
    },
    //表格列累计
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 0) {
          return
        }
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        // console.log(`${index}）${column.property}`)
        if (['payment_account'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }

          // // 格式化数据
          switch (column.property) {
            case 'payment_account':
              sums[index] = gFunc.numberFormat(sums[index], 2)
              break
            default:
              break
          }
        }
      })
      return sums
    },
    //提交合同信息
    saveContract(formName) {
      //保存合同归档：批量保存
      this.formContract.ids = this.orderContractList.map((item) => {
        return item.id
      })

      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveOrder({data: this.formContract, op: 'batch_other_info'}).then((res) => {
            if (!res.success) {
              this.$message.error(res.message)
            } else {
              this.$message.success(res.message)
              this.$emit('afterContract')
              this.close()
            }
          })
        } else {

          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>

<style scoped>

</style>
